<template>
  <v-container>
    <v-data-table
        :headers="headers"
        :items="patients"
        :search="search"
        class="elevation-1"
        :items-per-page="15"
        :hide-default-footer="true"
        :loading="loading"
        loading-text="Loading Patients..."
    >
      <template v-slot:top>
        <v-row>
          <v-col>
            <v-text-field
                placeholder="Last Name"
                v-model="search.last_name"
                label="Last Name"
                v-on:keydown.enter="onSearch"
            />
          </v-col>
          <v-col>
            <v-text-field
                placeholder="Claim No."
                v-model="search.claim_id"
                label="Claim No."
                v-on:keydown.enter="onSearch"
            />
          </v-col>
          <v-col>
            <v-btn color="success" class="mr-4" @click="onSearch">Search</v-btn>
            <v-btn class="mr-4" @click="reset">RESET</v-btn>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item="row">
        <tr>
          <td>{{ row.item.claim_id }}</td>
          <td>{{ row.item.patient_pin }}</td>
          <td>{{ row.item.last_name }}</td>
          <td>{{ row.item.first_name }}</td>
          <td>{{ row.item.middle_name }}</td>
          <td>{{ row.item.suffix }}</td>
          <td style="text-align: center">
            <v-btn
                class="mx-1"
                fab
                dark
                small
                color="blue"
                @click="create(row.item)"
            >
              <v-icon dark>mdi-account-plus</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: {
        last_name: "",
        claim_id: "",
      },
      headers: [
        {
          text: "Claim No",
          align: "start",
          value: "claim_id",
        },
        {text: "PIN", value: "pin"},
        {text: "Last Name", value: "last_name"},
        {text: "First Name", value: "first_name"},
        {text: "Middle Name", value: "middle_name"},
        {text: "Suffix", value: "suffix"},
        {
          text: "Actions",
          sortable: false,
          class: "text-center",
        },
      ],
      patients: [],
      loading: false,
    };
  },
  methods: {
    async list() {
      return await axios.post(
          "sureclaims-details",
          {
            data: this.search
          },
          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("AUTH_TOKEN"),
            }
          }
      );
    },
    async searchPatient(data) {
      return await axios.post(
          "/patient/getPatient/",
          {
            claim_id: data.claim_id,
          },
          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("AUTH_TOKEN"),
            },
          }
      );
    },
    async create(data) {
      const patient = await this.searchPatient(data);
      if (patient.data.data) {
        await this.$router.push({
          path: "/edit/" + patient.data.data.id,
        });
      } else {
        await this.$store.dispatch("setPatient", data);
        await this.$router.push({
          path: "/sureclaims/cf4/create/",
        });
      }
    },

    async reset() {
      this.search = {
        last_name: "",
        claim_id: "",
      }
      await this.loadList();
    },

    async onSearch() {
      await this.loadList();
    },

    async loadList() {
      this.loading = true;
      const {data} = await this.list();
      this.patients = data.data;
      this.loading = false;
    }

  },
  async mounted() {
    await this.loadList();
  },
};
</script>